// Copyright (c) 2020-2024 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import { Grid } from '@mui/material';
import Button, { ButtonProps } from '@shared/components/Button';

export interface MessageConfig {
  heading?: React.ReactNode;
  subheading?: React.ReactNode;
  icon?: React.ReactNode;
  buttonProps?: Partial<ButtonProps>;
}

export interface MessageProps extends MessageConfig {
  className?: string;
  classes?: Record<string, string>;
}

const Message: React.FC<MessageProps> = (props) => {
  const { heading, icon = null, subheading, buttonProps, ...otherProps } = props;
  const classes = withStyles.getClasses(props);

  return (
    <Grid
      container
      className={classes.root}
      justifyContent="center"
      alignItems="center"
      direction="column"
      {...otherProps}
    >
      {icon && <Grid item>{icon}</Grid>}
      {heading && <Grid item>{<h4 className={classes.heading}>{heading}</h4>}</Grid>}
      {subheading && <Grid item>{<h4 className={classes.subheading}>{subheading}</h4>}</Grid>}
      {buttonProps && <Button classes={{ root: classes.button }} {...buttonProps} />}
    </Grid>
  );
};

// Message.defaultProps = {
//   icon: null,
// };

const MessageStyled = withStyles(
  Message, 
  (theme, props) => ({
    "root": {
      padding: theme.spacing(3, 0),
      minHeight: 100,
      
      '& svg': {
        fontSize: 64,
        opacity: .2,
        fill: theme.palette.colors.primaryAccent,
      }
    },
    "heading": {
      fontSize: 24,
      margin: theme.spacing(0, 0, 1),
      textAlign: 'center' as const,
      color: theme.palette.colors.greyDark,
    },
    "subheading": {
      margin: 0,
      fontSize: 13,
      textAlign: 'center' as const,
      color: theme.palette.colors.greyLight3,
    },
    "button": {
      marginTop: theme.spacing(3)
    }
  })
);

export default MessageStyled;